module.exports = __webpack_public_path__ + "img/650f9289ec2639d82bf644e873fefcc5.png";